export class ContactModel {
    public id?: number;
    public name?: string;
    public pronounTreatment?: string;
    public phone?: string;
}
